import QuickMessage from '../models/quickMessage';
import urls from './urls';
import axios from 'axios';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';

// This file mocks a web API by working with the hard-coded data below.
// It uses setTimeout to simulate the delay of an AJAX call.
// All calls return promises.
// const results = [];
// for (let i = 0; i < 10; i++) {
//   const quickMessage = new QuickMessage();
//   quickMessage.TemplateID = i + 1;
//   quickMessage.UserID = 1;
//   quickMessage.Subject = 'Subject 1';
//   quickMessage.Message = `Content message aaa ${i}`;
//   results.push(quickMessage);
// }

class quickMessageApi {
  static loadAll(): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(urls.QUICK_MESSAGE_LOAD_ALL, ApiMethod.GET, params);
    return axios.get(urls.QUICK_MESSAGE_LOAD_ALL, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static addQuickMessage(params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(urls.QUICK_MESSAGE_ADD, ApiMethod.POST, params);
    const url = urls.QUICK_MESSAGE_ADD;
    return axios.post(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static updateQuickMessage(params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    let url = urls.QUICK_MESSAGE_UPDATE;
    url = url.replace('{templateId}', params.Id);
    // return this.restClient.execute(url, ApiMethod.PATCH, params);
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }

  static deleteQuickMessage(params: any): Promise<IApiResponse> {
    // this.restClient = new RestClient();
    // this.restClient.setBaseUrl(urls.BASE_RHPURL);
    // return this.restClient.execute(urls.QUICK_MESSAGE_DELETE, ApiMethod.PATCH, params);
    const url = urls.QUICK_MESSAGE_DELETE;
    return axios.patch(url, params, { baseURL: urls.BASE_RHPURL, headers: { isAnonymous: false } });
  }
}

export default quickMessageApi;
